import { InfoOutlined, KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { Card, CardContent, CardHeader, Collapse, IconButton, Stack, Switch } from '@mui/material'
import React, { useState } from 'react'
import MappingContent from './MappingContent';
import { singleEventType, singleMappingType } from '../../features/eventConfig/EventType';
import NoDataMessage from '../manageEvents/NoEventsMessage';

function SingleEvent(props: {
    event: singleEventType,
    updateEventState: (eventId: string, newSate: singleEventType) => void,
}) {
    const { event, updateEventState } = props
    const [open, setOpen] = useState<boolean>(false);

    const isActive = event.status === "active";

    const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        checked ? updateEventState(event.id, { ...event, status: 'active' }) : updateEventState(event.id, { ...event, status: 'disabled' })
    }

    const handleMappingDataChange = (type: string, updatedMapping: singleMappingType) => {
        const newData = {
            ...event,
            mappings: {
                ...event.mappings,
                [type]: { ...updatedMapping }
            }
        }
        updateEventState(event.id, newData)
    }

    return (
        <>
            <Card className={`event-config-single-event-card`}>
                <CardHeader
                    title={event?.id ?? ''}
                    className={`${open ? 'single-event-card-header-underline' : ''} ${!isActive ? 'event-config-disable-header' : ''}`}
                    action={
                        <Stack direction={"row"}>
                            <Switch
                                checked={isActive}
                                onChange={handleSwitchChange}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                            <IconButton size="small" className="validateCollapseToggleBtn" onClick={() => setOpen(!open)} disabled={!isActive}>
                                {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            </IconButton>

                        </Stack>
                    }
                />
                <div className='event-config-card-content-wrapper'>
                    {
                        !isActive && <div className='event-config-disable-overlay' />
                    }
                    {
                        open && <CardContent className='event-config-single-card-content'>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                {
                                    Object.keys(event?.mappings).length === 0 ? <NoDataMessage icon={<InfoOutlined />} /> :
                                        <Stack direction={"column"} gap={'16px'} >
                                            {event.mappings?.firebase && <MappingContent type={"Firebase"} mapping={event.mappings?.firebase} handleMappingDataChange={(updatedMapping: any) => handleMappingDataChange("firebase", updatedMapping)} />}
                                            {event.mappings?.moengage && <MappingContent type={"Moengage"} mapping={event.mappings?.moengage} handleMappingDataChange={(updatedMapping: any) => handleMappingDataChange("moengage", updatedMapping)} />}
                                            {event.mappings?.database && <MappingContent type={"Database"} mapping={event.mappings?.database} handleMappingDataChange={(updatedMapping: any) => handleMappingDataChange("database", updatedMapping)} />}
                                        </Stack>
                                }
                            </Collapse>
                        </CardContent>
                    }
                </div>
            </Card>
        </>
    )
}

export default SingleEvent